
import common_helper from '../../../../common_helper';
import CryptoJS from 'crypto-js';
import axios from 'axios';
import apiUrl from '../../../../constants';

import SalesChannelTat from '../saleschannel'


export default {
    name: 'slaglobal',
    components: {
        SalesChannelTat,
    },
    data() {
        return {
            renderComponent: true,
            accordianTab: {
                1: false,
                2: false,
                3: false,
            },
            inbound: {
                min: '',
                hrs: '',
                cuttofhrs: '',
                cuttofmin: '',
                cuttofday: 1,
                drhrs: '',
                drmin: '',
                drday: ''
            },
            outbound: {
                fixedhrs: '',
                fixedmin: '',
                cuttofhrs: '',
                cuttofmin: '',
                cuttofday: 1,
                orderhrs: '',
                ordermin: '',
                orderday: ''
            },
            fixedErr: "",
            cuttofErr: "",
            cutofInboundErr:"",
            cutofreturnsb2cErr:"",
            returnsb2cErr:"",
            cutofreturnsb2bErr:"",
            returnsb2bErr:"",
            inboundErr:"",
            outboundErr: "",
            ClientErr: this.$t("sla.clientrequired"),

            clientid: '',

            inboundConfigId:'',
			outboundConfigId:'',
			returnb2cConfigId:'',
			returnb2bConfigId:'',
            outboundSalesChannelData : [],
            returns: {
                min: '',
                hrs: '',
                b2bmin: '',
                b2bhrs: '',
                b2ccuttofhrs: '',
                b2ccuttofmin: '',
                b2ccuttofday: 1,
                b2cwhinscanhrs: '',
                b2cwhinscanmin: '',
                b2cwhinscanday: '',
                b2bcuttofhrs: '',
                b2bcuttofmin: '',
                b2bcuttofday: 1,
                b2bwhinscanhrs: '',
                b2bwhinscanmin: '',
                b2bwhinscanday: '',

            },
            listClientData: [
            ],
            listClientData: [],
            isLoading: false,
            tatType: "1",
            channellist: [],
            selectedChannelList: [],
            nonselectedChannelList: [],
            fixedInboundErr: "",
            ReturnsErr: "",
            b2bReturnsErr: "",
            globalThresholds: {
                inbound: {
                    hrs: null,
                    min: null,
                    cutOffBased:{
                        hrs:null,
                        min:null
                    }
                },
                outbound: {
                    fixedDuration: {
                        hrs: null,
                        min: null
                    },
                    cutOffBased: {
                        hrs: null,
                        min: null
                    }
                },
                returns: {
                    b2c: {
                        hrs: null,
                        min: null,
                        cutOffBased:{
                            hrs:null,
                            min:null
                        }
                    },
                    b2b: {
                        hrs: null,
                        min: null,
                        cutOffBased:{
                            hrs:null,
                            min:null
                        }
                    }
                }
            }

        }
    },
    computed: {},
    mounted() {
        this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
        this.inboundConfigID = localStorage.getItem("selectedClient")
        // this.getClientList(),
        this.getThresholdsGlobal();
        if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") ==''){
            this.$alertify.error(this.$t('common.clientError'))
        }
        else{
        this.getSalesChannels();
        this.getInboundConfig();
        this.getOutboundConfig();
        this.getReturnsConfig();
        }
    },

    methods: {

        async returnsReset() {
            await this.getReturnsConfig()
            this.returns.min = ""
            this.returns.hrs = ""
            this.returns.b2bmin = ""
            this.returns.b2bhrs = ""
            this.ReturnsErr = ""
            this.b2bReturnsErr = ""
            this.returns.b2ccuttofday = 1;
            this.returns.b2ccuttofhrs =  '';
            this.returns.b2ccuttofmin = '';
            this.returns.b2cwhinscanday = '';
            this.returns.b2cwhinscanhrs = '';
            this.returns.b2cwhinscanmin = '';
            this.returns.b2bcuttofday = 1;
            this.returns.b2bcuttofhrs =  '';
            this.returns.b2bcuttofmin = '';
            this.returns.b2bwhinscanday = '';
            this.returns.b2bwhinscanhrs = '';
            this.returns.b2bwhinscanmin = '';
            this.cutofreturnsb2cErr="",
            this.returnsb2cErr="",
            this.cutofreturnsb2bErr="",
            this.returnsb2bErr=""
        },
        async inboundReset() {
            await this.getInboundConfig()
            this.inbound.min = ""
            this.inbound.hrs = ""
            this.fixedInboundErr = ""
            this.inbound.cuttofhrs = ""
            this.inbound.cuttofmin = ""
            this.inbound.cuttofday = 1
            this.inbound.drhrs = ""
            this.inbound.drmin = ""
            this.inbound.drday = ""
            this.cutofInboundErr = ""
            this.inboundErr = ""
        },
        async outboundReset() {
            await this.getOutboundConfig();
            this.outbound.fixedhrs = ""
            this.outbound.fixedmin = ""
            this.outbound.b2bmin = ""
            this.outbound.cuttofhrs = ""
            this.outbound.cuttofmin = ""
            this.outbound.cuttofday = 1
            this.outbound.orderhrs = ""
            this.outbound.ordermin = ""
            this.outbound.orderday = ""
            this.fixedErr = ""
            this.cuttofErr = ""
            this.outboundErr = ""
            // this.tatType = "1"
            this.outboundSalesChannelData = []
            // await this.getOutboundConfig();
            console.log("/n/n OUT")
        },
        async getThresholdsGlobal(){
			const userToken = window.localStorage.getItem('userToken');
			const myStr = userToken.replace(/"/g, '');
			const inputInbound = ({
				slalevel: 'global',
				module: 'inbound',
			});
			const resultInbound = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'sla-configs',
				'params': inputInbound,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
			if(resultInbound.status == 200 && resultInbound.data.data.length > 0){
				const inboundConfig = resultInbound.data.data[0];
                if(inboundConfig.tattype === 'cutoff'){
                    this.globalThresholds.inbound.cutOffBased.hrs = inboundConfig.nearbreach && inboundConfig.nearbreach.hours || 0;
                    this.globalThresholds.inbound.cutOffBased.min = inboundConfig.nearbreach && inboundConfig.nearbreach.minutes || 0;
                    console.log("\n\nCutOFF", this.globalThresholds.inbound.cutOffBased.hrs, this.globalThresholds.inbound.cutOffBased.min)
                }else{
                this.globalThresholds.inbound.hrs = inboundConfig.nearbreach.hours || 0;
				this.globalThresholds.inbound.min = inboundConfig.nearbreach.minutes || 0;
                console.log("\n\nINBOUND", this.globalThresholds.inbound.hrs, this.globalThresholds.inbound.min)
                } 
			}

            //Outbound Thresholds
			const inputOutbound = ({
				slalevel: 'global',
				module: 'outbound',
			});
			const resultOutbound = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'sla-configs',
				'params': inputOutbound,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
			if(resultOutbound.status == 200 && resultOutbound.data.data.length > 0){
				const outboundConfig = resultOutbound.data.data[0];
				if(outboundConfig.tattype === 'cutoff'){
                this.globalThresholds.outbound.cutOffBased.hrs = outboundConfig.nearbreach && outboundConfig.nearbreach.hours || 0;
				this.globalThresholds.outbound.cutOffBased.min = outboundConfig.nearbreach && outboundConfig.nearbreach.minutes || 0;
                this.globalThresholds.outbound.fixedDuration.hrs = this.globalThresholds.outbound.cutOffBased.hrs;
				this.globalThresholds.outbound.fixedDuration.min = this.globalThresholds.outbound.cutOffBased.min;
                console.log("\n\nCutOFF", this.globalThresholds.outbound.cutOffBased.hrs, this.globalThresholds.outbound.cutOffBased.min)
				}else{
                this.globalThresholds.outbound.fixedDuration.hrs = outboundConfig.nearbreach && outboundConfig.nearbreach.hours || 0;
				this.globalThresholds.outbound.fixedDuration.min = outboundConfig.nearbreach && outboundConfig.nearbreach.minutes || 0;
                this.globalThresholds.outbound.cutOffBased.hrs = this.globalThresholds.outbound.fixedDuration.hrs;
				this.globalThresholds.outbound.cutOffBased.min = this.globalThresholds.outbound.fixedDuration.min;
                console.log("\n\nFIXED DURATION", this.globalThresholds.outbound.fixedDuration.hrs, this.globalThresholds.outbound.fixedDuration.min)
				}
			}

            //Returns Thresholds

			const inputb2c = ({
				slalevel: 'global',
				module: 'returnb2c',
			});
			const resultb2c = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'sla-configs',
				'params': inputb2c,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
			if(resultb2c.status == 200 && resultb2c.data.data.length > 0){
				const returnb2cConfig = resultb2c.data.data[0];
                if(returnb2cConfig === 'cutoff'){
                    this.globalThresholds.returns.b2c.cutOffBased.hrs = returnb2cConfig.nearbreach && returnb2cConfig.nearbreach.hours || 0;
                    this.globalThresholds.returns.b2c.cutOffBased.min = returnb2cConfig.nearbreach && returnb2cConfig.nearbreach.minutes || 0;
                    console.log("\n\nCutOFF", this.globalThresholds.returns.b2c.cutOffBased.hrs, this.globalThresholds.returns.b2c.cutOffBased.min)
                }else{
                this.globalThresholds.returns.b2c.hrs = returnb2cConfig.nearbreach.hours || 0;
				this.globalThresholds.returns.b2c.min = returnb2cConfig.nearbreach.minutes || 0;
                console.log("\n\nREETURNS B2C", this.globalThresholds.returns.b2c.hrs, this.globalThresholds.returns.b2c.min)
                }
			}

			const inputb2b = ({
				slalevel: 'global',
				module: 'returnb2b',
			});
			const resultb2b = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'sla-configs',
				'params': inputb2b,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
			if(resultb2b.status == 200 && resultb2b.data.data.length > 0){
				const returnb2bConfig = resultb2b.data.data[0];
                if(returnb2bConfig === 'cutoff'){
                    this.globalThresholds.returns.b2b.cutOffBased.hrs = returnb2bConfig.nearbreach && returnb2bConfig.nearbreach.hours || 0;
                    this.globalThresholds.returns.b2b.cutOffBased.min = returnb2bConfig.nearbreach && returnb2bConfig.nearbreach.minutes || 0;
                    console.log("\n\nCutOFF", this.globalThresholds.returns.b2b.cutOffBased.hrs, this.globalThresholds.returns.b2b.cutOffBased.min)
                }else{
                this.globalThresholds.returns.b2b.hrs = returnb2bConfig.nearbreach.hours || 0;
				this.globalThresholds.returns.b2b.min = returnb2bConfig.nearbreach.minutes || 0;
                console.log("\n\nRETURNS B2B", this.globalThresholds.returns.b2b.hrs, this.globalThresholds.returns.b2b.min)
                }
			}
		},
        async getInboundConfig(){
            if (localStorage.getItem("selectedClient") == 'undefined') {
                this.WarehouseErr = this.$t('common.clientError');
                this.$alertify.error(this.$t('common.clientError'))
                return false;
              }
              if (localStorage.getItem("selectedWarehouse") == 'undefined') {
                this.WarehouseErr = this.$t('common.warehouseError');
                this.$alertify.error(this.$t('common.warehouseError'))
                return false;
              }
            // this.inboundReset();
			const userToken = window.localStorage.getItem('userToken');
			const myStr = userToken.replace(/"/g, '');
			const input = ({
                clientid: localStorage.getItem("selectedClient"),
				slalevel: 'client',
				module: 'inbound',
			});
			const result = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'sla-configs',
				'params': input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
			if(result.status == 200 && result.data.data.length > 0){
				const inboundConfig = result.data.data[0];
				this.inboundConfigId = inboundConfig.id;
                if(inboundConfig.tattype === 'cutoff'){
					this.inbound.cuttofday = inboundConfig.tattime && inboundConfig.tattime.days ? inboundConfig.tattime.days : 0;
					this.inbound.cuttofhrs = inboundConfig.tattime && inboundConfig.tattime.hours ? inboundConfig.tattime.hours : 0;
					this.inbound.cuttofmin = inboundConfig.tattime && inboundConfig.tattime.minutes || 0;
					this.inbound.drday = inboundConfig.outboundsla && inboundConfig.outboundsla.days ? inboundConfig.outboundsla.days : 0;
					this.inbound.drhrs = inboundConfig.outboundsla && inboundConfig.outboundsla.hours ? inboundConfig.outboundsla.hours: 0;
					this.inbound.drmin = inboundConfig.outboundsla && inboundConfig.outboundsla.minutes || 0;
					this.tatType= "2";
				}else{
				this.inbound.hrs = inboundConfig.tattime.hours || 0;
				this.inbound.min =  inboundConfig.tattime.minutes || 0;
                this.tatType= "1";
                }
			}
            else{
                this.inboundConfigId = '';
                this.inbound.hrs = 0;
                this.inbound.min = 0;
            }

		},
        async transitFixedDurAndCutoffBased(){
            // this.selectedChannelList = []
            // this.nonselectedChannelList = []
            // this.channellist = []
            this.outboundSalesChannelData = []
            await this.getOutboundConfig();
            await this.getInboundConfig();
            await this.getReturnsConfig();
            this.tatType = "2";
        },
		async getOutboundConfig(){
            if (localStorage.getItem("selectedClient") == 'undefined') {
                this.WarehouseErr = this.$t('common.clientError');
                this.$alertify.error(this.$t('common.clientError'))
                return false;
              }
              if (localStorage.getItem("selectedWarehouse") == 'undefined') {
                this.WarehouseErr = this.$t('common.warehouseError');
                this.$alertify.error(this.$t('common.warehouseError'))
                return false;
              }
            // this.outboundReset();
			const userToken = window.localStorage.getItem('userToken');
			const myStr = userToken.replace(/"/g, '');
			const input = ({
                clientid: localStorage.getItem("selectedClient"),
				slalevel: 'client',
				module: 'outbound',
			});
			const result = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'sla-configs',
				'params': input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
			if(result.status == 200 && result.data.data.length > 0){
				const outboundData = [];
                result.data.data.map((item)=>{
                    if(item.saleschannel){
                        this.outboundSalesChannelData.push(item);
                        this.nonselectedChannelList = this.nonselectedChannelList.filter(e=> e.saleschannel != item.saleschannel);
                        this.nonselectedChannelList.sort((a, b) => a.saleschannel > b.saleschannel ? 1 : -1)
                    }else{
                        outboundData.push(item);
                    }
                })
                const outboundConfig = outboundData[0];
				this.outboundConfigId = outboundConfig.id;
				if(outboundConfig.tattype === 'cutoff'){
					this.outbound.cuttofday = outboundConfig.tattime && outboundConfig.tattime.days ? outboundConfig.tattime.days : 0;
					this.outbound.cuttofhrs =  outboundConfig.tattime && outboundConfig.tattime.hours ? outboundConfig.tattime.hours : 0;
					this.outbound.cuttofmin = outboundConfig.tattime && outboundConfig.tattime.minutes || 0;
					this.outbound.orderday = outboundConfig.outboundsla && outboundConfig.outboundsla.days ? outboundConfig.outboundsla.days : 0;
					this.outbound.orderhrs = outboundConfig.outboundsla && outboundConfig.outboundsla.hours ? outboundConfig.outboundsla.hours: 0;
					this.outbound.ordermin = outboundConfig.outboundsla && outboundConfig.outboundsla.minutes || 0;
					this.tatType= "2";
				}else{
					this.outbound.fixedhrs = outboundConfig.tattime && outboundConfig.tattime.hours || 0;
					this.outbound.fixedmin =  outboundConfig.tattime && outboundConfig.tattime.minutes || 0;
					this.tatType= "1";
				}
			}

		},
		async getReturnsConfig(){
            if (localStorage.getItem("selectedClient") == 'undefined') {
                this.WarehouseErr = this.$t('common.clientError');
                this.$alertify.error(this.$t('common.clientError'))
                return false;
              }
              if (localStorage.getItem("selectedWarehouse") == 'undefined') {
                this.WarehouseErr = this.$t('common.warehouseError');
                this.$alertify.error(this.$t('common.warehouseError'))
                return false;
              }
            // this.returnsReset();
			const userToken = window.localStorage.getItem('userToken');
			const myStr = userToken.replace(/"/g, '');
			const inputb2c = ({
                clientid: localStorage.getItem("selectedClient"),
				slalevel: 'client',
				module: 'returnb2c',
			});
			const resultb2c = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'sla-configs',
				'params': inputb2c,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
			if(resultb2c.status == 200 && resultb2c.data.data.length > 0){
				const returnb2cConfig = resultb2c.data.data[0];
				this.returnb2cConfigId = returnb2cConfig.id;
                if(returnb2cConfig.tattype === 'cutoff'){
					this.returns.b2ccuttofday = returnb2cConfig.tattime && returnb2cConfig.tattime.days ? returnb2cConfig.tattime.days : 0;
					this.returns.b2ccuttofhrs = returnb2cConfig.tattime && returnb2cConfig.tattime.hours ? returnb2cConfig.tattime.hours : 0;
					this.returns.b2ccuttofmin = returnb2cConfig.tattime && returnb2cConfig.tattime.minutes || 0;
					this.returns.b2cwhinscanday = returnb2cConfig.outboundsla && returnb2cConfig.outboundsla.days ? returnb2cConfig.outboundsla.days : 0;
					this.returns.b2cwhinscanhrs = returnb2cConfig.outboundsla && returnb2cConfig.outboundsla.hours ? returnb2cConfig.outboundsla.hours: 0;
					this.returns.b2cwhinscanmin = returnb2cConfig.outboundsla && returnb2cConfig.outboundsla.minutes || 0;
					this.tatType= "2";
				}else{
				this.returns.hrs = returnb2cConfig.tattime.hours || 0;
				this.returns.min =  returnb2cConfig.tattime.minutes || 0;
                this.tatType= "1";
                }
			}

			const inputb2b = ({
                clientid: localStorage.getItem("selectedClient"),
				slalevel: 'client',
				module: 'returnb2b',
			});
			const resultb2b = await axios({
				method: 'GET',
				'url': apiUrl.api_url + 'sla-configs',
				'params': inputb2b,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
			if(resultb2b.status == 200 && resultb2b.data.data.length > 0){
				const returnb2bConfig = resultb2b.data.data[0];
				this.returnb2bConfigId = returnb2bConfig.id;
                if(returnb2bConfig.tattype === 'cutoff'){
					this.returns.b2bcuttofday = returnb2bConfig.tattime && returnb2bConfig.tattime.days ? returnb2bConfig.tattime.days : 0;
					this.returns.b2bcuttofhrs = returnb2bConfig.tattime && returnb2bConfig.tattime.hours ? returnb2bConfig.tattime.hours : 0;
					this.returns.b2bcuttofmin = returnb2bConfig.tattime && returnb2bConfig.tattime.minutes || 0;
					this.returns.b2bwhinscanday = returnb2bConfig.outboundsla && returnb2bConfig.outboundsla.days ? returnb2bConfig.outboundsla.days : 0;
					this.returns.b2bwhinscanhrs = returnb2bConfig.outboundsla && returnb2bConfig.outboundsla.hours ? returnb2bConfig.outboundsla.hours: 0;
					this.returns.b2bwhinscanmin = returnb2bConfig.outboundsla && returnb2bConfig.outboundsla.minutes || 0;
					this.tatType= "2";
				}else{
				this.returns.b2bhrs = returnb2bConfig.tattime.hours || 0;
				this.returns.b2bmin =  returnb2bConfig.tattime.minutes || 0;
                this.tatType= "1";
                }
			}
		},
        async deleteChannel(saleschannel, outboundConfigId) {
            const payload = {};
            const userToken = window.localStorage.getItem('userToken');
            const myStr = userToken.replace(/"/g, '');
            payload.clientid= localStorage.getItem("selectedClient");
            payload.slalevel= 'client';
            payload.module= "outbound";
            payload.saleschannel= saleschannel;
            const result = await axios({
                method: 'DELETE',
                'url': apiUrl.api_url + 'sla-configs' + `/${outboundConfigId ? outboundConfigId : ''}`,
                'data': payload,
                headers: {
                    'Authorization': 'Bearer ' + myStr,
                }
            })
            if(result.status == 200 && result.data.data){
                this.$alertify.success(this.$t(`apiErrors.${result.data.errorLabel}`));
                const saleschannel = payload.saleschannel;
                if (saleschannel) {
                    this.outboundSalesChannelData = this.outboundSalesChannelData.filter(item=> item.saleschannel != saleschannel);
                    this.nonselectedChannelList.push({saleschannel: saleschannel})
                    this.nonselectedChannelList.sort((a, b) => a.saleschannel > b.saleschannel ? 1 : -1)
                }
            }else{
                this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`));
            }
        },
        async saveNewChannel(payload, outboundConfigId) {
            const userToken = window.localStorage.getItem('userToken');
            const myStr = userToken.replace(/"/g, '');
            payload.clientid= this.clientid;
            payload.slalevel= 'client';
            payload.module= "outbound";
            const result = await axios({
                method: 'PUT',
                'url': apiUrl.api_url + 'sla-configs' + `/${outboundConfigId ? outboundConfigId : ''}`,
                'data': payload,
                headers: {
                    'Authorization': 'Bearer ' + myStr,
                }
            })
            if(result.status == 200 && result.data.data){
                this.$alertify.success(this.$t(`apiErrors.${result.data.errorLabel}`));
                const saleschannel = payload.saleschannel;
                if (saleschannel) {
                    this.outboundSalesChannelData = this.outboundSalesChannelData.filter(item=> item.saleschannel != '' && item.saleschannel != saleschannel);
                    this.outboundSalesChannelData.push(result.data.data)
                    this.nonselectedChannelList = this.nonselectedChannelList.filter(item=>item.saleschannel != saleschannel);
                    this.nonselectedChannelList.sort((a, b) => a.saleschannel > b.saleschannel ? 1 : -1)
                }
            }else{
                this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`));
            }
        },
        addChannelToSelectList() {
            if (this.channellist.length > 0 && (this.channellist.length > this.selectedChannelList.length) && !this.selectedChannelList.find(o => o.saleschannel === 'dummy')) {

                this.outboundSalesChannelData.push({
                    clientid: localStorage.getItem("selectedClient"),
                    module: 'outbound',
                    nearbreach: '',
                    outboundsla: '',
                    saleschannel: '',
                    slalevel: 'client',
                    tattime: '',
                    tattype: '',
                })
            }
        },
        // clientSelected() {
        //     this.selectedChannelList = []
        //     this.nonselectedChannelList = []
        //     this.channellist = []
        //     this.outboundSalesChannelData = []
        //     if(this.clientid){
        //         this.getSalesChannels()
        //         this.getOutboundConfig();
        //         this.getInboundConfig();
        //         this.getReturnsConfig();
        //     }
        // },
        async getSalesChannels() {
            if (localStorage.getItem("selectedClient") == 'undefined') {
                this.WarehouseErr = this.$t('common.clientError');
                this.$alertify.error(this.$t('common.clientError'))
                return false;
              }
              if (localStorage.getItem("selectedWarehouse") == 'undefined') {
                this.WarehouseErr = this.$t('common.warehouseError');
                this.$alertify.error(this.$t('common.warehouseError'))
                return false;
              }
            const result = await common_helper.getRestApiResponse('POST', 'orderSalesChannelList', { clientid: localStorage.getItem("selectedClient") },)
            this.channellist = result.data.data;
            this.nonselectedChannelList = [...this.channellist]
            this.nonselectedChannelList.sort((a, b) => a.saleschannel > b.saleschannel ? 1 : -1)
        },
        // async getClientList() {
        //     if (window.localStorage.getItem("clientList") !== null) {
        //         const clientListEncrypt = window.localStorage.getItem('clientList');
        //         const clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
        //         const plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
        //         this.listClientData = JSON.parse(plaintextclient);

        //     } else {
        //         this.listClientData = [];

        //         let result = await common_helper.getRestApiResponse('POST', 'getWarehouseAssociatedClientList', {}, this.$alertify)

        //         this.listClientData = result.data.data;

        //     }
        // },
        onSubmit(e) {
            switch (e.type) {
                case 'inbound':
                    this.saveConfigInbound();
                    break
                case 'outbound':
                    this.saveConfigOutbound();
                    break
                case 'returns':
                    this.saveConfigReturns();
                    break
                default:
                    return this.$t("sla.invalidip")
                    break
            }
        },
        toggleCheck(tabid) {
            for (var key in this.accordianTab) {
                if (tabid != key) {
                    this.accordianTab[key] = false;
                }
            }
        },
        async saveConfigInbound(){
            if (localStorage.getItem("selectedClient") == 'undefined') {
                this.WarehouseErr = this.$t('common.clientError');
                this.$alertify.error(this.$t('common.clientError'))
                return false;
              }
              if (localStorage.getItem("selectedWarehouse") == 'undefined') {
                this.WarehouseErr = this.$t('common.warehouseError');
                this.$alertify.error(this.$t('common.warehouseError'))
                return false;
              }
            await this.getThresholdsGlobal();
            if(this.tatType === '1'){
            if(parseInt(this.globalThresholds.inbound.hrs*60) + parseInt(this.globalThresholds.inbound.min) >= parseInt(this.inbound.hrs*60) + parseInt(this.inbound.min)){
                this.$alertify.alert(this.$t('sla.durationError'), this.$t('sla.durationErrMsg') + "<br/>" + `<b> ${this.$t('sla.thresholdDuration')}: ${this.globalThresholds.inbound.hrs} ${this.$t('sla.hours')} ${this.globalThresholds.inbound.min} ${this.$t('sla.minutes')} </b>`);
                return false;
            }
			this.$validator.validateAll('tab1').then(async(result) => {
				if (result) {
					if(this.inbound.hrs==0 && this.inbound.min==0){
						this.fixedInboundErr=this.$t('sla.hrMinErr');
						}
					else{
						this.fixedInboundErr='';
						//calling update api
						const userToken = window.localStorage.getItem('userToken');
						const myStr = userToken.replace(/"/g, '');
						const input = {
                            clientid: localStorage.getItem("selectedClient"),
                            slalevel: 'client',
							module: "inbound",
							tattype: "fixed",
							tattime: `${this.inbound.hrs}:${this.inbound.min}`,
					 	};
						const result = await axios({
							method: 'PUT',
							'url': apiUrl.api_url + 'sla-configs' + `/${this.inboundConfigId ? this.inboundConfigId : ''}`,
							'data': input,
							headers: {
								'Authorization': 'Bearer ' + myStr,
							}
						})
						if(result.status == 200 && result.data.data){
							this.$alertify.success(this.$t(`apiErrors.${result.data.errorLabel}`));
                            this.inbound.cuttofday = 1;
                            this.inbound.cuttofhrs =  '';
                            this.inbound.cuttofmin = '';
                            this.inbound.drday = '';
                            this.inbound.drhrs = '';
                            this.inbound.drmin = '';

						}else{
							this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`));
						}
					}
				} else {
					console.log("Invalid")
				}
			  });
            }
            else{
                this.$validator.validateAll('tab5').then(async(result) => {
                    if (result) {
                        if((this.inbound.cuttofday==0 && this.inbound.cuttofhrs==0 && this.inbound.cuttofmin==0)){
                            this.cutofInboundErr=this.$t('sla.allZeroErr');
                            return false;
                        }else if((this.inbound.drday==0 && this.inbound.drhrs==0 && this.inbound.drmin==0)){
                            this.inboundErr=this.$t('sla.allZeroErr');
                            return false;
                        }
                        else{
                            let totalDrMins = parseInt(this.inbound.drday*24*60) + parseInt(this.inbound.drhrs*60) + parseInt(this.inbound.drmin);
                            let totalCutoffMins = parseInt(this.inbound.cuttofday*24*60) + parseInt(this.inbound.cuttofhrs*60) + parseInt(this.inbound.cuttofmin)
                            if(totalCutoffMins >= totalDrMins){
                                this.inboundErr = this.$t('sla.inboundSlaAndDrCreationCutoff');
                                return false;
                            }
                            this.cutofInboundErr='';
                            this.inboundErr='';

                            if(parseInt(this.globalThresholds.inbound.cutOffBased.hrs*60) + parseInt(this.globalThresholds.inbound.cutOffBased.min) >= totalDrMins - totalCutoffMins ){
                                this.$alertify.alert(this.$t('sla.durationError'), this.$t('sla.durationErrMsg') + "<br/>" + `<b> ${this.$t('sla.thresholdDuration')}: ${this.globalThresholds.inbound.cutOffBased.hrs} ${this.$t('sla.hours')} ${this.globalThresholds.inbound.cutOffBased.min} ${this.$t('sla.minutes')} </b>`);
                                return false;
                            }
                        // update api call
                        const userToken = window.localStorage.getItem('userToken');
                        const myStr = userToken.replace(/"/g, '');
                        const input = {
                            clientid: localStorage.getItem("selectedClient"),
                            slalevel: 'client',
                            module: "inbound",
                            tattype: "cutoff",
                            tattime: `${this.inbound.cuttofday} ${this.inbound.cuttofhrs}:${this.inbound.cuttofmin}`,
                            outboundsla: `${this.inbound.drday} ${this.inbound.drhrs}:${this.inbound.drmin}`
                        };
                        const result = await axios({
                            method: 'PUT',
                            'url': apiUrl.api_url + 'sla-configs' + `/${this.inboundConfigId ? this.inboundConfigId : ''}`,
                            'data': input,
                            headers: {
                                'Authorization': 'Bearer ' + myStr,
                            }
                        })
                        if(result.status == 200 && result.data.data){
                            this.$alertify.success(this.$t(`apiErrors.${result.data.errorLabel}`));
                            this.inbound.hrs = '';
                            this.inbound.min =  '';
                        }else{
                            this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`));
                        }
                    }
                    } else {
                        console.log("tab5 Invalid")
                    }
                });
            }
		},
        async saveConfigOutbound(){
            if (localStorage.getItem("selectedClient") == 'undefined') {
                this.WarehouseErr = this.$t('common.clientError');
                this.$alertify.error(this.$t('common.clientError'))
                return false;
              }
              if (localStorage.getItem("selectedWarehouse") == 'undefined') {
                this.WarehouseErr = this.$t('common.warehouseError');
                this.$alertify.error(this.$t('common.warehouseError'))
                return false;
              }
            await this.getThresholdsGlobal();
            if(this.tatType === '1'){
                this.$validator.validateAll('tab2').then(async(result) => {
                    if (result) {
                        if(this.outbound.fixedhrs==0 && this.outbound.fixedmin==0){
                            this.fixedErr=this.$t('sla.hrMinErr');
                            return false;
                        }
                        else{
                            if(parseInt(this.globalThresholds.outbound.fixedDuration.hrs*60) + parseInt(this.globalThresholds.outbound.fixedDuration.min) >= parseInt(this.outbound.fixedhrs*60) + parseInt(this.outbound.fixedmin)){
                                this.$alertify.alert(this.$t('sla.durationError'), this.$t('sla.durationErrMsg') + "<br/>" + `<b> ${this.$t('sla.thresholdDuration')}: ${this.globalThresholds.outbound.fixedDuration.hrs} ${this.$t('sla.hours')} ${this.globalThresholds.outbound.fixedDuration.min} ${this.$t('sla.minutes')} </b>`);
                                return false;
                            }
                            this.fixedErr='';
                            // update api call
                            const userToken = window.localStorage.getItem('userToken');
                            const myStr = userToken.replace(/"/g, '');
                            const input = {
                                clientid: localStorage.getItem("selectedClient"),
                                slalevel: 'client',
                                module: "outbound",
                                tattype: "fixed",
                                tattime: `${this.outbound.fixedhrs}:${this.outbound.fixedmin}`
                            };
                            const result = await axios({
                                method: 'PUT',
                                'url': apiUrl.api_url + 'sla-configs' + `/${this.outboundConfigId ? this.outboundConfigId : ''}`,
                                'data': input,
                                headers: {
                                    'Authorization': 'Bearer ' + myStr,
                                }
                            })
                            if(result.status == 200 && result.data.data){
                                this.$alertify.success(this.$t(`apiErrors.${result.data.errorLabel}`));
                                this.outbound.cuttofday = 1;
                                this.outbound.cuttofhrs =  '';
                                this.outbound.cuttofmin = '';
                                this.outbound.orderday = '';
                                this.outbound.orderhrs = '';
                                this.outbound.ordermin = '';
                            }else{
                                this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`));
                            }
                        }
                    } else {
                        console.log("tab2 Invalid")
                    }
                });
            }
            else{
                this.$validator.validateAll('tab4').then(async(result) => {
                    if (result) {
                        if((this.outbound.cuttofday==0 && this.outbound.cuttofhrs==0 && this.outbound.cuttofmin==0)){
                            this.cuttofErr=this.$t('sla.allZeroErr');
                            return false;
                        }else if((this.outbound.orderday==0 && this.outbound.orderhrs==0 && this.outbound.ordermin==0)){
                            this.outboundErr=this.$t('sla.allZeroErr');
                            return false;
                        }
                        else{
                            let totalOrderMins = parseInt(this.outbound.orderday*24*60) + parseInt(this.outbound.orderhrs*60) + parseInt(this.outbound.ordermin);
                            let totalCutoffMins = parseInt(this.outbound.cuttofday*24*60) + parseInt(this.outbound.cuttofhrs*60) + parseInt(this.outbound.cuttofmin)
                            if(totalCutoffMins >= totalOrderMins){
                                this.outboundErr = this.$t('sla.OutboundSlaAndOrderCreationCutoff');
                                return false;
                            }
                            this.cuttofErr='';
                            this.outboundErr='';

                            if(parseInt(this.globalThresholds.outbound.cutOffBased.hrs*60) + parseInt(this.globalThresholds.outbound.cutOffBased.min) >= totalOrderMins - totalCutoffMins ){
                                this.$alertify.alert(this.$t('sla.durationError'), this.$t('sla.durationErrMsg') + "<br/>" + `<b> ${this.$t('sla.thresholdDuration')}: ${this.globalThresholds.outbound.cutOffBased.hrs} ${this.$t('sla.hours')} ${this.globalThresholds.outbound.cutOffBased.min} ${this.$t('sla.minutes')} </b>`);
                                return false;
                            }
                        // update api call
                        const userToken = window.localStorage.getItem('userToken');
                        const myStr = userToken.replace(/"/g, '');
                        const input = {
                            clientid: localStorage.getItem("selectedClient"),
                            slalevel: 'client',
                            module: "outbound",
                            tattype: "cutoff",
                            tattime: `${this.outbound.cuttofday} ${this.outbound.cuttofhrs}:${this.outbound.cuttofmin}`,
                            outboundsla: `${this.outbound.orderday} ${this.outbound.orderhrs}:${this.outbound.ordermin}`
                        };
                        const result = await axios({
                            method: 'PUT',
                            'url': apiUrl.api_url + 'sla-configs' + `/${this.outboundConfigId ? this.outboundConfigId : ''}`,
                            'data': input,
                            headers: {
                                'Authorization': 'Bearer ' + myStr,
                            }
                        })
                        if(result.status == 200 && result.data.data){
                            this.$alertify.success(this.$t(`apiErrors.${result.data.errorLabel}`));
                            this.outbound.fixedhrs = '';
                            this.outbound.fixedmin =  '';
                        }else{
                            this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`));
                        }
                    }
                    } else {
                        console.log("tab4 Invalid")
                    }
                });
            }
		},
		async saveConfigReturns(){
            if (localStorage.getItem("selectedClient") == 'undefined') {
                this.WarehouseErr = this.$t('common.clientError');
                this.$alertify.error(this.$t('common.clientError'))
                return false;
              }
              if (localStorage.getItem("selectedWarehouse") == 'undefined') {
                this.WarehouseErr = this.$t('common.warehouseError');
                this.$alertify.error(this.$t('common.warehouseError'))
                return false;
              }
            await this.getThresholdsGlobal();
            if(this.tatType === '1'){
			this.$validator.validateAll('tab3').then(async(result) => {
				if (result) {
				if((this.returns.hrs==0 && this.returns.min==0)){
					this.ReturnsErr=this.$t('sla.hrMinErr');
                   return false;
				}else if(this.returns.b2bhrs==0 && this.returns.b2bmin==0){
                    this.b2bReturnsErr = this.$t('sla.hrMinErr');
                    return false;
                }
				else{
					this.ReturnsErr='';
                    this.b2bReturnsErr='';
				}
				// update api call
                if(parseInt(this.globalThresholds.returns.b2c.hrs*60) + parseInt(this.globalThresholds.returns.b2c.min) >= parseInt(this.returns.hrs*60) + parseInt(this.returns.min)){
                    this.$alertify.alert(this.$t('sla.durationError'), '<b>' + this.$t('sla.b2creturns') + '</b>' + "&nbsp" + this.$t('sla.durationErrMsg') + "<br/>" + `<b> ${this.$t('sla.thresholdDuration')}: ${this.globalThresholds.returns.b2c.hrs} ${this.$t('sla.hours')} ${this.globalThresholds.returns.b2c.min} ${this.$t('sla.minutes')} </b>`);
                    return false;
                }
                if(parseInt(this.globalThresholds.returns.b2b.hrs*60) + parseInt(this.globalThresholds.returns.b2b.min) >= parseInt(this.returns.b2bhrs*60) + parseInt(this.returns.b2bmin)){
                    this.$alertify.alert(this.$t('sla.durationError'), '<b>' + this.$t('sla.b2breturns') + '</b>' + "&nbsp" + this.$t('sla.durationErrMsg') + "<br/>" + `<b> ${this.$t('sla.thresholdDuration')}: ${this.globalThresholds.returns.b2b.hrs} ${this.$t('sla.hours')} ${this.globalThresholds.returns.b2b.min} ${this.$t('sla.minutes')} </b>`);
                    return false;
                }
				const userToken = window.localStorage.getItem('userToken');
				const myStr = userToken.replace(/"/g, '');
				const input = {
                    clientid: localStorage.getItem("selectedClient"),
                    slalevel: 'client',
					module: "returnb2c",
					tattype: "fixed",
					tattime: `${this.returns.hrs}:${this.returns.min}`
				};
				const result = await axios({
					method: 'PUT',
					'url': apiUrl.api_url + 'sla-configs' + `/${this.returnb2cConfigId ? this.returnb2cConfigId : ''}`,
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				const input2 = {
                    clientid: localStorage.getItem("selectedClient"),
                    slalevel: 'client',
					module: "returnb2b",
					tattype: "fixed",
					tattime: `${this.returns.b2bhrs}:${this.returns.b2bmin}`
				};
				const result2 = await axios({
					method: 'PUT',
					'url': apiUrl.api_url + 'sla-configs' + `/${this.returnb2bConfigId ? this.returnb2bConfigId : ''}`,
					'data': input2,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})

				if(result.status == 200 && result.data.data && result2.status == 200 && result2.data.data){
					this.$alertify.success(this.$t(`apiErrors.${result.data.errorLabel}`));
                    this.returns.b2ccuttofday = 1;
                    this.returns.b2ccuttofhrs =  '';
                    this.returns.b2ccuttofmin = '';
                    this.returns.b2cwhinscanday = '';
                    this.returns.b2cwhinscanhrs = '';
                    this.returns.b2cwhinscanmin = '';
                    this.returns.b2bcuttofday = 1;
                    this.returns.b2bcuttofhrs =  '';
                    this.returns.b2bcuttofmin = '';
                    this.returns.b2bwhinscanday = '';
                    this.returns.b2bwhinscanhrs = '';
                    this.returns.b2bwhinscanmin = '';
				}else{
					this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`));
				}
				} else {
				console.log("Invalid")
				}
			  });
            }else{
                this.$validator.validateAll('tab6').then(async(result) => {
                    if (result) {
                        if((this.returns.b2ccuttofday==0 && this.returns.b2ccuttofhrs==0 && this.returns.b2ccuttofmin==0)){
                            this.cutofreturnsb2cErr=this.$t('sla.allZeroErr');
                            return false;
                        }else if((this.returns.b2cwhinscanday==0 && this.returns.b2cwhinscanhrs==0 && this.returns.b2cwhinscanmin==0)){
                            this.returnsb2cErr=this.$t('sla.allZeroErr');
                            return false;
                        }else if((this.returns.b2bcuttofday==0 && this.returns.b2bcuttofhrs==0 && this.returns.b2bcuttofmin==0)){
                            this.returnsb2bErr=this.$t('sla.allZeroErr');
                            return false;
                        }else if((this.returns.b2bwhinscanday==0 && this.returns.b2bwhinscanhrs==0 && this.returns.b2bwhinscanmin==0)){
                            this.returnsb2bErr=this.$t('sla.allZeroErr');
                            return false;
                        }    
                        else{
                            let totalb2cwhinscanMins = parseInt(this.returns.b2cwhinscanday*24*60) + parseInt(this.returns.b2cwhinscanhrs*60) + parseInt(this.returns.b2cwhinscanmin);
                            let totalCutoffMinsb2c = parseInt(this.returns.b2ccuttofday*24*60) + parseInt(this.returns.b2ccuttofhrs*60) + parseInt(this.returns.b2ccuttofmin)
                            if(totalCutoffMinsb2c >= totalb2cwhinscanMins){
                                this.returnsb2cErr = this.$t('sla.Returnsb2cSlaAndWHInscanCreationCutoff');
                                return false;
                            }
                            this.cutofreturnsb2cErr='';
                            this.returnsb2cErr='';
                            

                            if(parseInt(this.globalThresholds.returns.b2c.cutOffBased.hrs*60) + parseInt(this.globalThresholds.returns.b2c.cutOffBased.min) >= totalb2cwhinscanMins - totalCutoffMinsb2c ){
                                this.$alertify.alert(this.$t('sla.durationError'), this.$t('sla.durationErrMsg') + "<br/>" + `<b> ${this.$t('sla.thresholdDuration')}: ${this.globalThresholds.returns.b2c.cutOffBased.hrs} ${this.$t('sla.hours')} ${this.globalThresholds.returns.b2c.cutOffBased.min} ${this.$t('sla.minutes')} </b>`);
                                return false;
                            }

                            let totalb2bwhinscanMins = parseInt(this.returns.b2bwhinscanday*24*60) + parseInt(this.returns.b2bwhinscanhrs*60) + parseInt(this.returns.b2bwhinscanmin);
                            let totalCutoffMinsb2b = parseInt(this.returns.b2bcuttofday*24*60) + parseInt(this.returns.b2bcuttofhrs*60) + parseInt(this.returns.b2bcuttofmin)
                            if(totalCutoffMinsb2b >= totalb2bwhinscanMins){
                                this.returnsb2bErr = this.$t('sla.Returnsb2bSlaAndWHInscanCreationCutoff');
                                return false;
                            }
                            this.cutofreturnsb2bErr='';
                            this.returnsb2bErr='';
                            

                            if(parseInt(this.globalThresholds.returns.b2b.cutOffBased.hrs*60) + parseInt(this.globalThresholds.returns.b2b.cutOffBased.min) >= totalb2bwhinscanMins - totalCutoffMinsb2b ){
                                this.$alertify.alert(this.$t('sla.durationError'), this.$t('sla.durationErrMsg') + "<br/>" + `<b> ${this.$t('sla.thresholdDuration')}: ${this.globalThresholds.returns.b2b.cutOffBased.hrs} ${this.$t('sla.hours')} ${this.globalThresholds.returns.b2b.cutOffBased.min} ${this.$t('sla.minutes')} </b>`);
                                return false;
                            }

                            
                        
                        // update api call
                        const userToken = window.localStorage.getItem('userToken');
                        const myStr = userToken.replace(/"/g, '');
                        const input = {
                            clientid: localStorage.getItem("selectedClient"),
                            slalevel: 'client',
                            module: "returnb2c",
                            tattype: "cutoff",
                            tattime: `${this.returns.b2ccuttofday} ${this.returns.b2ccuttofhrs}:${this.returns.b2ccuttofmin}`,
                            outboundsla: `${this.returns.b2cwhinscanday} ${this.returns.b2cwhinscanhrs}:${this.returns.b2cwhinscanmin}`
                        };
                        const result = await axios({
                            method: 'PUT',
                            'url': apiUrl.api_url + 'sla-configs' + `/${this.returnb2cConfigId ? this.returnb2cConfigId : ''}`,
                            'data': input,
                            headers: {
                                'Authorization': 'Bearer ' + myStr,
                            }
                        })

                        const input2 = {
                            clientid: localStorage.getItem("selectedClient"),
                            slalevel: 'client',
                            module: "returnb2b",
                            tattype: "cutoff",
                            tattime: `${this.returns.b2bcuttofday} ${this.returns.b2bcuttofhrs}:${this.returns.b2bcuttofmin}`,
                            outboundsla: `${this.returns.b2bwhinscanday} ${this.returns.b2bwhinscanhrs}:${this.returns.b2bwhinscanmin}`
                        };

                        const result2 = await axios({
                            method: 'PUT',
                            'url': apiUrl.api_url + 'sla-configs' + `/${this.returnb2bConfigId ? this.returnb2bConfigId : ''}`,
                            'data': input2,
                            headers: {
                                'Authorization': 'Bearer ' + myStr,
                            }
                        })


                        if(result.status == 200 && result.data.data&& result2.status == 200 && result2.data.data){
                            this.$alertify.success(this.$t(`apiErrors.${result.data.errorLabel}`));
                            this.returns.min = ""
                            this.returns.hrs = ""
                            this.returns.b2bmin = ""
                            this.returns.b2bhrs = ""
                            this.ReturnsErr = ""
                            this.b2bReturnsErr = ""
                        }else{
                            this.$alertify.error(this.$t(`apiErrors.${result.data.errorLabel}`));
                        }
                    
                    }
                    } else {
                        console.log("tab6 Invalid")
                    }
                });
            }
            },

        }

    }


// WEBPACK FOOTER //
// ./src/views/components/SLA/slaclient/slaclient.component.js